export default __webpack_public_path__ + "static/media/mail.aecade3a.svg";